import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  DocumentUploadBody,
  ExperiencePrivate,
  RequestNumber,
  StepAboutYouCO,
  StepAboutYouMX,
  StepAboutYouResponse,
  StepExperience,
  StepExperienceDelivery,
  StepExperienceMobility,
  StepInicioCo,
  StepMoreInformation,
  StepOCRDaeResponse,
  StepOCRLtoResponse,
  StepOptionUber,
  StepSecondaryDocuments,
  StepWelcome,
  StepWelcomeLto,
  StepWhereDoYouLiveCo,
} from '../interfaces/step-data';

@Injectable({
  providedIn: 'root',
})
export class PutDataService {
  constructor(private http: HttpClient) { }
  ////////NUEVO DAE//////////////////
  //// COLOMBIA ////
  ///STEP INICIO ///
  putUpdateStepInitCo(
    countryCode: string,
    applicationId: string,
    stepInit: StepInicioCo
  ): Observable<[]> {
    return this.http.put<[]>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}`,
      stepInit
    );
  }
  ///STEP EXPERIENCIA////
  putUpdateStepExperienceCo(
    countryCode: string,
    applicationId: string,
    stepExperience: StepExperience
  ): Observable<[]> {
    return this.http.put<[]>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/experience`,
      stepExperience
    );
  }
  ///STEP SOBRE TI ///
  putUpdateStepAboutYouCo(
    countryCode: string,
    applicationId: string,
    stepAboutYou: StepAboutYouCO
  ): Observable<[]> {
    return this.http.put<[]>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/about-you`,
      stepAboutYou
    );
  }
  ///STEP DONDE VIVES ///
  putUpdateStepWhereDoYouLiveCo(
    countryCode: string,
    applicationId: string,
    stepWhereDoYouLive: StepWhereDoYouLiveCo
  ): Observable<[]> {
    return this.http.put<[]>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/location`,
      stepWhereDoYouLive
    );
  }
  ///STEP DOCUMENTOS
  putUpdateRequestDocumentsCo(
    countryCode: string,
    applicationId: string
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/documents`,
      null
    );
  }
  ///// MEXICO ///
  //// STEP BIENVENIDA //
  putUpdateRequestWelcome(
    countryCode: string,
    applicationId: string,
    stepWelcome: StepWelcome
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}`,
      stepWelcome
    );
  }
  //STEP SOBRE TI
  putUpdateRequestAboutYou(
    countryCode: string,
    applicationId: string,
    stepAboutYou: StepAboutYouMX
  ): Observable<StepAboutYouResponse> {
    return this.http.put<StepAboutYouResponse>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/prefilter`,
      stepAboutYou
    );
  }
  /// STEP DATOS UBER //
  putUpdateRequestDataUber(
    countryCode: string,
    applicationId: string
  ): Observable<StepAboutYouResponse> {
    return this.http.put<StepAboutYouResponse>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/uber`,
      null
    );
  }
  ///Guardar opcion data uber
  putSaveOptionUber(
    countryCode: string,
    applicationId: string,
    stepOptionUber: StepOptionUber
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/uber/option`,
      stepOptionUber
    );
  }
  /// CARGA DOCUMENTOS
  putUpdateRequestLoadDocuments(
    countryCode: string,
    applicationId: string
  ): Observable<StepOCRDaeResponse> {
    return this.http.put<StepOCRDaeResponse>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/documents
      `,
      null
    );
  }
  //STEP MAS INFORMACION
  putUpdateMoreInformation(
    countryCode: string,
    applicationId: string,
    stepMoreInformation: StepMoreInformation
  ): Observable<RequestNumber> {
    return this.http.put<RequestNumber>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/more-information`,
      stepMoreInformation
    );
  }

  ///// NUEVO FLUJO LTO ///
  //// STEP BIENVENIDA //
  putUpdateRequestWelcomeLto(
    countryCode: string,
    applicationId: string,
    stepWelcomeLto: StepWelcomeLto
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}`,
      stepWelcomeLto
    );
  }

  /// STEP DATOS UBER LTO//
  ///si dio acceso a uber o no
  putUpdateRequestDataUberLto(
    countryCode: string,
    applicationId: string,
  ): Observable<StepAboutYouResponse> {
    return this.http.put<StepAboutYouResponse>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/uber`,
      null
    );
  }

  ///Guardar opcion data uber
  putSaveOptionUberLto(
    countryCode: string,
    applicationId: string,
    stepOptionUber: StepOptionUber
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/uber/option`,
      stepOptionUber
    );
  }

  /// DEVUELVE DATOS OCR
  putUpdateRequestMainDocuments(countryCode: string, applicationId: string, body?: DocumentUploadBody): Observable<StepOCRLtoResponse> {
    return this.http.put<StepOCRLtoResponse>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/main-documents`,
      body || null
    );
  }

  ///GUARDAR VALIDACION DATOS
  putUpdateRequestDataValidation(
    countryCode: string,
    applicationId: string,
    validation: any
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/validation`,
      validation
    );
  }
  ///GUARDAR DATOS VISITAS - DOCUMENTOS SECUNDARIOS
  putUpdateRequestSecondaryDocuments(
    countryCode: string,
    applicationId: string,
    visit: StepSecondaryDocuments
  ): Observable<''> {
    return this.http.put<''>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/secondary-documents`,
      visit
    );
  }

  //STEP MAS INFORMACION
  putUpdateMoreInformationLto(
    countryCode: string,
    applicationId: string,
    stepMoreInformation: StepMoreInformation
  ): Observable<RequestNumber> {
    return this.http.put<RequestNumber>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/more-information`,
      stepMoreInformation
    );
  }
}
